import { ChartSectionProps } from 'utils/chart-options/chart-collection';
import EmptyDataScreen from './EmptyDataScreen';

const ChartSection = ({
  data,
  datasets,
  chart,
  isRuleof40 = false,
  hasData,
  labels
}: ChartSectionProps) => {
  return hasData(data, labels, isRuleof40) ? (
    <div className='flex flex-col'>
      <div className='h-[372px]'>{chart}</div>
      <div className='flex flex-wrap items-center gap-x-4 w-[calc(100%-70px)]'>
        {datasets.map((dataset, index) => (
          <div key={index} className='flex items-center gap-2'>
            <div
              className={`w-4 h-4 ${
                dataset.pointStyle === 'rectRot' ? 'rotate-45' : ''
              }  ${dataset.pointStyle === 'circle' ? 'rounded-full' : ''}`}
              style={{ backgroundColor: dataset.backgroundColor }}
            ></div>
            {dataset.labelComponent || (
              <p className='dark:text-gray-400'>{dataset.label}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  ) : (
    <EmptyDataScreen className='div2PDF' />
  );
};

export default ChartSection;
